import {STATE_PROP_NAME} from './storyline-view-constants'

export const getStorylineViewState = state => state[STATE_PROP_NAME]
export const getStorylineId = state => getStorylineViewState(state).storylineId
